import React from "react";
import styled from "styled-components";
import { ReactComponent as FirmLogo } from "src/assets/logo.svg";
import { ReactComponent as CollapsedLogo } from "src/assets/collapsedLogo.svg";

const Container = styled.a<{ $isCollapsed: boolean }>`
  height: 152px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: ${({ $isCollapsed }) => ($isCollapsed ? "0 10px" : "0 24px")};

  /* The artwork is 563px wide (66px collapsed), so flexbox squeezed it to
     whatever the sidebar had left — edge to edge — while the height attribute
     kept the box far taller than the logo drawn inside it. Cap the width and
     let the height follow the viewBox instead. */
  svg {
    width: 100%;
    height: auto;
    max-width: ${({ $isCollapsed }) => ($isCollapsed ? "32px" : "152px")};
  }
`;

const Logo: React.FC<{ isCollapsed: boolean }> = ({ isCollapsed }) => {
  return (
    <Container $isCollapsed={isCollapsed}>
      {isCollapsed ? <CollapsedLogo /> : <FirmLogo />}
    </Container>
  );
};

export default Logo;
